module.exports = __webpack_public_path__ + "img/business2.ba4f0f03.png";